import { render, staticRenderFns } from "./SoTruongForm.vue?vue&type=template&id=703f57fa&"
import script from "./SoTruongForm.vue?vue&type=script&lang=js&"
export * from "./SoTruongForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports